/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import { cleanExternalLinks } from '../../lib/utils';

// import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/blocks/heading.scss';

const propTypes = {
    heading: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    heading: null,
    className: null,
};

const HeadingBlock = ({ heading, className }) => {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {heading !== null ? <h4 className={styles.heading}>{heading}</h4> : null}
        </div>
    );
};

HeadingBlock.propTypes = propTypes;
HeadingBlock.defaultProps = defaultProps;

export default HeadingBlock;
